var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.apps_status.length
      ? _c(
          "table",
          _vm._l(_vm.apps_status, function(statusMessage) {
            return _c(
              "tr",
              { key: statusMessage.project, class: statusMessage.color },
              [
                _c(
                  "td",
                  [
                    _c(
                      "v-chip",
                      {
                        staticClass: "black--text",
                        attrs: { label: "", small: "", color: "#00000022" }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(statusMessage.project) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "black--text" }, [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(statusMessage.message) + "\n\t\t\t"
                  )
                ])
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a20ee51", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a20ee51","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/App_status_message.vue
// module id = null
// module chunks = 